import React, { useEffect } from 'react';
import { Form, Button, Space, Alert } from 'antd';
import { SaveOutlined, InfoCircleOutlined } from '@ant-design/icons';
import type { KrybotTemplate } from '../../../types/krybot';
import { JsonSchemaEditor } from '../AgentManagement/JsonSchemaEditor';
import styles from './TemplateManagement.module.css';

interface TemplateMetadataTabProps {
  template: KrybotTemplate | null;
  templateData: Partial<KrybotTemplate>;
  isCreating: boolean;
  onDataChange: (updates: Partial<KrybotTemplate>) => void;
  onSave: () => void;
  loading: boolean;
}

export const TemplateMetadataTab: React.FC<TemplateMetadataTabProps> = ({
  template,
  templateData,
  isCreating,
  onDataChange,
  onSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      metadata: templateData.metadata || {},
    });
  }, [templateData.metadata, form]);

  const handleChange = (value: Record<string, unknown> | null) => {
    onDataChange({ metadata: value || {} });
  };

  const validateJson = (_: unknown, value: Record<string, unknown> | null) => {
    if (!value) {
      return Promise.resolve();
    }
    return Promise.resolve();
  };

  return (
    <div className="template-metadata-tab">
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Template Metadata</h3>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          loading={loading}
        >
          Save Changes
        </Button>
      </div>
      <Alert
        message="Template Metadata"
        description="JSON metadata for the template. This can include input_schema, output_schema, or other template-specific configuration."
        type="info"
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 16 }}
      />
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          metadata: templateData.metadata || {},
        }}
      >
        <Form.Item
          name="metadata"
          rules={[{ validator: validateJson }]}
          help="JSON metadata for the template. Use code mode to edit as JSON."
        >
          <JsonSchemaEditor
            fieldType="input_schema" // Use input_schema type to get code editor
            disabled={loading}
            value={templateData.metadata}
            onChange={handleChange}
            placeholder='{"input_schema": {...}, "output_schema": {...}, ...}'
          />
        </Form.Item>
      </Form>
    </div>
  );
};

